<script lang="ts">
  export const name = 'Play';
  export let className = '';
</script>

<svg class={className} viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.38128 5.45497L2.14914 1.04035C2.02867 0.964005 1.88955 0.922226 1.74695 0.919569C1.60436 0.916912 1.46377 0.953479 1.34054 1.02528C1.21549 1.09389 1.11125 1.19493 1.03878 1.31778C0.966303 1.44063 0.928282 1.58075 0.928715 1.72338V10.5627C0.928282 10.7053 0.966303 10.8454 1.03878 10.9683C1.11125 11.0911 1.21549 11.1922 1.34054 11.2608C1.46377 11.3326 1.60436 11.3691 1.74695 11.3665C1.88955 11.3638 2.02867 11.322 2.14914 11.2457L9.38128 6.83108C9.49982 6.75957 9.59787 6.65865 9.66593 6.5381C9.734 6.41755 9.76976 6.28146 9.76976 6.14302C9.76976 6.00459 9.734 5.8685 9.66593 5.74795C9.59787 5.6274 9.49982 5.52648 9.38128 5.45497Z"
  />
</svg>
